import { AppDispatch, RootState } from "../../store";
import { startLoginUser } from "../../store/auth";

import { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Link as RouterLink, useNavigate } from "react-router-dom";

import {
  Grid,
  TextField,
  Button,
  Link,
  InputAdornment,
  IconButton,
  CircularProgress,
  Alert,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import { AuthLayout } from "../../layouts";
import { regularExps } from "../../helpers/validators";

type Inputs = {
  email: string;
  password: string;
};

export const LoginPage = () => {
  const { status, errorMessage } = useSelector(
    (state: RootState) => state.auth
  );

  const isChecking = status === "checking";

  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<Inputs>({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const onSubmit = async (data: Inputs) => {
    const result = await dispatch(startLoginUser(data.email, data.password));

    if (result.success) {
      navigate("/");
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };

  return (
    <AuthLayout title="Iniciar sesión" linkTo="register">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container alignItems="center" justifyContent="center">
          <Grid item xs={12} mb={3}>
            <TextField
              type="email"
              placeholder="Correo"
              fullWidth
              color="secondary"
              {...register("email", {
                required: "Este campo es requerido",
                pattern: {
                  value: regularExps.email,
                  message: "Este campo debe ser un correo electrónico válido",
                },
              })}
              error={!!errors.email}
              helperText={errors.email?.message}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                    borderBottom: "2px solid white",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                    borderBottom: "2px solid white",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                    borderBottom: "2px solid white",
                  },
                },
                "& .MuiInputBase-input": {
                  color: "white",
                },
                "& .MuiFormLabel-root": {
                  color: "white",
                },
                "& .MuiFormHelperText-root": {
                  color: "white",
                },
              }}
              InputProps={{
                style: {
                  color: "white",
                },
              }}
              InputLabelProps={{
                style: {
                  color: "white",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} mb={2}>
            <TextField
              type={showPassword ? "text" : "password"}
              placeholder="Contraseña"
              fullWidth
              color="secondary"
              {...register("password", {
                required: "Este campo es requerido",
              })}
              error={!!errors.password}
              helperText={errors.password?.message}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                    borderBottom: "2px solid white",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                    borderBottom: "2px solid white",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                    borderBottom: "2px solid white",
                  },
                },
                "& .MuiInputBase-input": {
                  color: "white",
                },
                "& .MuiFormLabel-root": {
                  color: "white",
                },
                "& .MuiFormHelperText-root": {
                  color: "white",
                },
              }}
              InputProps={{
                style: {
                  color: "white",
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{
                style: {
                  color: "white",
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Grid item mb={2} display={errorMessage ? "" : "none"}>
              <Alert severity="error">{errorMessage}</Alert>
            </Grid>

            <Button
              disabled={isChecking}
              variant="contained"
              type="submit"
              fullWidth
              sx={{
                borderRadius: 2,

                padding: 1.5,
                fontSize: "1.1rem",
                my: 4,
              }}
            >
              {isChecking ? (
                <CircularProgress style={{ color: "#CE3197", padding: 10 }} />
              ) : (
                "Ingresar"
              )}
            </Button>
          </Grid>

          <Grid item xs={12} sx={{ textAlign: "center" }}>
            <Link
              component={RouterLink}
              to={`/auth/reset-password`}
              variant="body2"
              color="text.primary"
            >
              ¿Olvidó su contraseña?
            </Link>
          </Grid>
        </Grid>
      </form>
    </AuthLayout>
  );
};
